import BootstrapField from '../utility/BootstrapField';
import IsEqual from 'lodash.isequal';

let originalUserData = null;

export default class RegisterUser {

	static get getRoleOptions() {
		return [
			{
				id: 'agency_user',
				name: 'Construction Agency User'
			},
			{
				id: 'agency_admin',
				name: 'Construction Agency Administrator'
			},
			{
				id: 'agency_supervisor',
				name: 'Construction Agency Supervisor'
			},
			{
				id: 'internal_admin_requests',
				name: 'Internal Administrator - Requests'
			},
			{
				id: 'officer_requests',
				name: 'Enforcement Officer'
			},
			{
				id: 'read_only',
				name: 'Read-only User'
			},
			{
				id: 'system_admin',
				name: 'System Admin'
			}
		];
	}

	static get getYesNoOptions() {
		return [
			{
				text: 'Yes',
				value: 1
			},
			{
				text: 'No',
				value: 0
			}
		];
	}

	static get getYesNoUserAwayOptions() {
		return [
			{
				text: 'Yes',
				value: 1
			},
			{
				text: 'No',
				value: 0
			}
		];
	}
	static get getEmailConfirmedOptions() {
		return [
			{
				text: 'Confirmed',
				value: 1
			},
			{
				text: 'Not Confirmed',
				value: 0
			}
		];
	}


	static get getActiveOptions() {
		return [
			{
				text: 'Active',
				value: 1
			},
			{
				text: 'Not Active',
				value: 0
			}
		];
	}

	static get getApprovedOptions() {
		return [
			{
				text: 'Approved',
				value: 1
			},
			{
				text: 'Rejected',
				value: 0
			}
		];
	}

	static get getSortOptions() {
		return [
			{
				text: 'Name A->Z',
				value: 'fullName asc',
			},
			{
				text: 'Name Z->A',
				value: 'fullName desc',
			},
			{
				text: 'Created Date - Newest Entry First',
				value: 'createdDate desc',
			},
			{
				text: 'Created Date - Oldest Entry First',
				value: 'createdDate asc',
			},
		]
	}

	defaultNotificationSetting(notificationTypeId, myLcr, allLcr) {
		return {
			notificationTypeId: notificationTypeId,
			notifyEmailAllLcr: allLcr,
			notifyEmailMyLcr: myLcr,
			notifyAppAllLcr: allLcr,
			notifyAppMyLcr: myLcr,
			notifyBrowserAllLcr: allLcr,
			notifyBrowserMyLcr: 1,  // always turn on browser 
			notifySoundAllLcr: allLcr,
			notifySoundMyLcr: myLcr,
		};
	}



	constructor(data) {
		if (!data) {
			data = {};
		}

		if (data.useDefaultNotificationSettings) {
			data.notificationSetting = [
				// this.defaultNotificationSetting('lcr-status-updated', 1, 0),
				this.defaultNotificationSetting('lcr-approved', 1, 0),
				this.defaultNotificationSetting('lcr-cancelled', 1, 0),
				this.defaultNotificationSetting('lcr-completed', 1, 0),
				this.defaultNotificationSetting('lcr-denied', 1, 0),
				this.defaultNotificationSetting('new-lcr', 0, 0),
				this.defaultNotificationSetting('lcr-updated', 1, 0),
				this.defaultNotificationSetting('lcr-change-request', 0, 0),
				this.defaultNotificationSetting('lcr-new-message', 1, 0),
				this.defaultNotificationSetting('lcr-contact-added', 1, 0),
				this.defaultNotificationSetting('lcr-contact-removed', 0, 0),
				this.defaultNotificationSetting('r-reminder-place', 1, 0),
				this.defaultNotificationSetting('lc-reminder-close', 1, 0),
				this.defaultNotificationSetting('lc-reminder-open', 1, 0),
				this.defaultNotificationSetting('r-reminder-remove', 1, 0),
				this.defaultNotificationSetting('lc-closed', 1, 0),
				this.defaultNotificationSetting('lc-opened', 1, 0),
				this.defaultNotificationSetting('r-placed', 0, 0),
				this.defaultNotificationSetting('r-removed', 0, 0),
				this.defaultNotificationSetting('lc-not-opened', 1, 0),
				this.defaultNotificationSetting('r-not-removed', 0, 0),
				this.defaultNotificationSetting('r-not-placed', 0, 0),
				this.defaultNotificationSetting('lc-not-closed', 1, 0),
				this.defaultNotificationSetting('new-contravention', 1, 0),
				this.defaultNotificationSetting('contravention-new-message', 1, 0),
				this.defaultNotificationSetting('lcr-attachment', 1, 0),

			];
		}

		Object.assign(this, {
			id: data.id || null,
			organizationId: new BootstrapField({
				value: data.organizationId || null,
				fnRawValue: function() {
					if (this.value == null) {
						return null;
					}
					if (this.value.id != null) {
						return this.value.id;
					} else {
						return this.value;
					}
				}
			}),
			name: new BootstrapField({
				value: data.name || null,
			}),
			domain: new BootstrapField({
				value: data.domain || null,
			}),
			username: new BootstrapField({
				value: data.username || null,
				required: true,
			}),
			password: new BootstrapField({
				value: data.password || null,
				required: true
			}),
			existingPassword: new BootstrapField({
				value: data.existingPassword || null,
			}),
			fullName: new BootstrapField({
				value: data.fullName || null,
			}),
			firstName: new BootstrapField({
				value: data.firstName || null,
				required: true,
			}),
			lastName: new BootstrapField({
				value: data.lastName || null,
				required: true,
			}),
			title: new BootstrapField({
				value: data.title || null,
			}),
			email: new BootstrapField({
				value: data.email || null,
				required: true,
			}),
			phone: new BootstrapField({
				value: data.phone || null,
				required: true,
			}),
			altPhone: new BootstrapField({
				value: data.altPhone || null,
			}),
			supervisorUserId: new BootstrapField({
				value: data.supervisorUserId || null,
			}),
			alternateUserId: new BootstrapField({
				value: data.alternateUserId || null,
			}),
			comments: new BootstrapField({
				value: data.comments || null,
			}),
			awayUserId: new BootstrapField({
				value: data.awayUserId || null,
			}),
			isAway: new BootstrapField({
				value: typeof data.isAway === 'number' ? data.isAway : null,
			}),
			isApproved: new BootstrapField({
				value: typeof data.isApproved === 'number' ? data.isApproved : null,
			}),
			isActive: new BootstrapField({
				value: typeof data.isActive === 'number' ? data.isActive : null,
			}),
			isEmailConfirmed: new BootstrapField({
				value: typeof data.isEmailConfirmed === 'number' ? data.isEmailConfirmed : null,

			}),
			createdDate: new BootstrapField({
				value: data.createdDate || null,
			}),
			createdUserId: new BootstrapField({
				value: data.createdUserId || null,
			}),
			modifiedDate: new BootstrapField({
				value: data.modifiedDate || null,
			}),
			modifiedUserId: new BootstrapField({
				value: data.modifiedUserId || null,
			}),
			notifyEmailAllLcr: new BootstrapField({
				value: typeof data.notifyEmailAllLcr === 'number' ? data.notifyEmailAllLcr : null,
				fnRawValue: function() {
					if (this.value != null) {
						if (this.value == true) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			}),
			notifyEmailMyLcr: new BootstrapField({
				value: typeof data.notifyEmailMyLcr === 'number' ? data.notifyEmailMyLcr : null,
				fnRawValue: function() {
					if (this.value != null) {
						if (this.value == true) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			}),
			notifyAppAllLcr: new BootstrapField({
				value: typeof data.notifyAppAllLcr === 'number' ? data.notifyAppAllLcr : null,
				fnRawValue: function() {
					if (this.value != null) {
						if (this.value == true) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			}),
			notifyAppMyLcr: new BootstrapField({
				value: typeof data.notifyAppMyLcr === 'number' ? data.notifyAppMyLcr : null,
				fnRawValue: function() {
					if (this.value != null) {
						if (this.value == true) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			}),
			notifyBrowserAllLcr: new BootstrapField({
				value: typeof data.notifyBrowserAllLcr === 'number' ? data.notifyBrowserAllLcr : null,
				fnRawValue: function() {
					if (this.value != null) {
						if (this.value == true) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			}),
			notifyBrowserMyLcr: new BootstrapField({
				value: typeof data.notifyBrowserMyLcr === 'number' ? data.notifyBrowserMyLcr : null,
				fnRawValue: function() {
					if (this.value != null) {
						if (this.value == true) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			}),
			notifySoundAllLcr: new BootstrapField({
				value: typeof data.notifySoundAllLcr === 'number' ? data.notifySoundAllLcr : null,
				fnRawValue: function() {
					if (this.value != null) {
						if (this.value == true) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			}),
			notifySoundMyLcr: new BootstrapField({
				value: typeof data.notifySoundMyLcr === 'number' ? data.notifySoundMyLcr : null,
				fnRawValue: function() {
					if (this.value != null) {
						if (this.value == true) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return 0;
					}
				}
			}),
			roles: new BootstrapField({
				value: data.roles || []
			}),
			notificationSetting: new BootstrapField({
				value: data.notificationSetting || [],
				fnRawValue: function() {
					let newVal = [];
					for (let arrI in this.value) {
						newVal.push(Object.assign({}, this.value[arrI]));
					}

					return newVal;
				}
			}),
			allowedOrganizations: new BootstrapField({
				value: data.allowedOrganizations || []
			}),
			additionalEmail: new BootstrapField({
				value: data.additionalEmail || []
			}),

		});


		// Keep a record of the old data. (used for the hasChanges() method)
		// originalUserData = CloneDeep(this);
		originalUserData = this.getRawValue();
	}

	validate() {
		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getRawValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getRawValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}
	hasChanges() {
		return !IsEqual(originalUserData, this.getRawValue());
		// return false;
	}
	revertChanges() {
		this.constructor(originalUserData);
	}
	saveChanges() {
		// originalUserData = CloneDeep(this);
		originalUserData = this.getRawValue();
	}
}